// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/index.css
// module id = 1053
// module chunks = 2